.envoltorio {
  display: inline-flex;
  align-items: flex-start;
  gap: var(--s-5);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.envoltorio[data-disabled] {
  cursor: not-allowed;
}
/* Píldora: 38 de alto, borde gray-300, pista de 34×20 y etiqueta semibold; prendida se lava de accent-50. */
.envoltorio[data-variant="pill"] {
  --_perilla: var(--s-6);
  align-items: center;
  gap: var(--s-5);
  height: 38px;
  padding: 0 var(--s-6) 0 var(--s-5);
  border: var(--bw-hair) solid var(--border-strong);
  border-radius: var(--r-full);
  background: var(--surface-card);
  transition:
    background var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard);
}
.envoltorio[data-variant="pill"]:has(.oculto:checked) {
  background: var(--surface-brand-faint);
  border-color: var(--border-brand-soft);
}
@media (hover: hover) {
  .envoltorio[data-variant="pill"]:not([data-disabled]):hover {
    border-color: var(--border-hover);
  }
}
.envoltorio[data-variant="pill"] .pista {
  width: 34px;
}
.envoltorio[data-variant="pill"] .oculto:checked + .pista .perilla {
  transform: translateX(14px);
}
.envoltorio[data-variant="pill"] .texto {
  padding-top: 0;
}
.envoltorio[data-variant="pill"] .etiqueta {
  font-weight: var(--fw-semibold);
}

.oculto {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  outline: none;
  box-shadow: none;
}

/* La pista mide 36×20 y la perilla 16: 2px de aire por lado. Apagada gray-300, prendida accent. */
.pista {
  --_perilla: var(--s-6);
  --_aire: 2px;
  position: relative;
  flex: 0 0 auto;
  width: calc(var(--_perilla) * 2 + var(--_aire) * 2);
  height: calc(var(--_perilla) + var(--_aire) * 2);
  border-radius: var(--r-full);
  background: var(--border-strong);
  transition:
    background var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}
.perilla {
  position: absolute;
  top: var(--_aire);
  left: var(--_aire);
  width: var(--_perilla);
  height: var(--_perilla);
  border-radius: var(--r-full);
  background: var(--brand-white);
  box-shadow: var(--sh-knob);
  transition: transform var(--dur-fast) var(--ease-standard);
}

.oculto:checked + .pista {
  background: var(--action-primary);
}
.oculto:checked + .pista .perilla {
  transform: translateX(var(--_perilla));
}
.oculto:focus-visible + .pista {
  box-shadow: var(--ring-focus);
}
.oculto:disabled + .pista {
  background: var(--control-disabled-border);
}
.oculto:disabled + .pista .perilla {
  background: var(--control-disabled-bg);
  box-shadow: none;
}

.texto {
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
  min-width: 0;
  /* Alineado con el centro de la pista. */
  padding-top: 1px;
}
.etiqueta {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-strong);
}
.descripcion {
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  line-height: var(--lh-normal);
  color: var(--text-muted);
}
.envoltorio[data-disabled] .etiqueta {
  color: var(--control-disabled-text);
}

@media (prefers-reduced-motion: reduce) {
  .pista,
  .perilla {
    transition: none;
  }
}
